import axios from '../utils/axiosConfig'

export const sendMessage = async (text, file) => {
  // A doc upload must go multipart (DRF reads request.FILES from it); a plain
  // text message stays JSON so the request shape is unchanged.
  let body = { message: text }
  if (file) {
    body = new FormData()
    body.append('message', text)
    body.append('doc_file', file)
  }
  const { data } = await axios.post('/api/chat/send/', body)
  return data
}

export const getSession = async (sessionId) => {
  const { data } = await axios.get('/api/chat/session/', { params: { session_id: sessionId } })
  return data
}

// EventSource cannot set request headers, and the stream view authenticates via
// `Authorization: Token <token>`. Read the SSE stream with fetch instead.
export const subscribeStream = (jobId, onEvent) => {
  const token = localStorage.getItem('authToken')
  const controller = new AbortController()
  const url = `/api/chat/stream/?job_id=${encodeURIComponent(jobId)}`
  fetch(url, { headers: { Authorization: `Token ${token}` }, signal: controller.signal })
    .then((res) => {
      // A rejected request (expired token, stale job id) returns a JSON error
      // body with no SSE frames, so report it instead of hanging on "working…".
      if (!res.ok) { onEvent({ status: 'failed' }); return }
      if (!res.body) return
      const reader = res.body.getReader()
      const decoder = new TextDecoder()
      let buffer = ''
      const read = () =>
        reader.read()
          .then(({ done, value }) => {
            if (done) return
            buffer += decoder.decode(value, { stream: true })
            let idx
            while ((idx = buffer.indexOf('\n\n')) !== -1) {
              const frame = buffer.slice(0, idx)
              buffer = buffer.slice(idx + 2)
              const dataLine = frame.split('\n').find((l) => l.startsWith('data: '))
              if (dataLine) {
                try { onEvent(JSON.parse(dataLine.slice(6))) } catch { /* ignore */ }
              }
            }
            return read()
          })
          // An abort mid-read rejects; that is expected teardown, not an error.
          .catch(() => {})
      return read()
    })
    // A thrown fetch (server unreachable, network down) rejects before any frame
    // arrives, so report it or the UI stays on "working…" forever. An abort is
    // expected teardown, not a failure.
    .catch((err) => {
      if (err?.name !== 'AbortError') onEvent({ status: 'failed' })
    })
  return () => controller.abort()
}
